// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1syWr","label":"CategoryService_label__X5Sbp","location":"CategoryService_location__2gEvW"};